/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Grid, Toolbar, ButtonGroup, Button, Badge, Form, Input,
} from '@cgn/framework-ui-components/v1';
import {
  OrarioIcon, BusinessContactIcon, SearchIcon, ArchivioIcon, DownIcon,
} from '@cgn/framework-ui-components/icons';
import { connect } from 'react-redux';
import findIndex from 'lodash/array/findIndex';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import Enums from '../Shared/Enums';
import Actions from './Actions';
import CustomAccordion from '../Shared/CustomAccordion';
import ListaQuesiti from './ListaQuesiti';
import ListaMessaggi from './ListaMessaggi';
import { getQueryParams } from '../Shared/Utils';
import { withEventiServer } from '../Shared/EventiServer/EventiServerContext';
import { messaggiServerEnum } from '../Exports/iframeComunication';
import ModaleNuovoQuesito from '../NuovoQuesito/ModaleNuovoQuesito';
import ProfiloContext from '../Shared/Profilo/ProfiloContext';

const { Row } = Grid;
const { Col } = Grid;

const Visualizza = {
  Quesiti: 0,
  Comunicazioni: 1,
};

class Messaggi extends Component {
  state = {
    modaleNuovoQuesito: false,
    visualizza: Visualizza.Quesiti,
    quesitiVisualizzati: Enums.Quesiti.Aperti,
    canaliTematici: [],
    quesiti: [],
    ricerca: '',
    pannelloSelezionato: 0,
    numeroQuesitiNonLetti: 0,
    quesitiApertiNonLetti: 0,
    quesitiChiusiNonLetti: 0,
    idCanaleSelezionato: 0,
  };

  eventiServerSubscriptions = [];

  getChildContext() {
    return {
      impostaQuesiti: (q) => {
        this.props.impostaQuesitiDaLeggere(q.filter((x) => !x.LettaDaUtente).length);
        this.setState({ quesiti: q, quesitiApertiNonLetti: q.filter((x) => x.Aperta && !x.LettaDaUtente).length, quesitiChiusiNonLetti: q.filter((x) => !x.Aperta && !x.LettaDaUtente).length });
      },
      verificaQuesitiNonLetti: this.verificaQuesitiNonLetti,
      caricaCanaliTematici: this.caricaCanaliTematici,
    };
  }

  componentDidMount() {
    const { eventiServerContext } = this.props;
    const ufficioSelezionato = getQueryParams(this.props.location.search).ufficio;

    this.caricaCanaliTematici();
    this.impostaPaginaSelezionata(this.props);
    this.verificaQuesitiNonLetti(ufficioSelezionato);

    this.eventiServerSubscriptions = [
      eventiServerContext.subscribe(messaggiServerEnum.NuovoMessaggioPubblicato, this.caricaCanaliTematici),
      eventiServerContext.subscribe(messaggiServerEnum.RispostaInviata, () => this.verificaQuesitiNonLetti()),
      eventiServerContext.subscribe(messaggiServerEnum.PrerispostaInviata, () => this.verificaQuesitiNonLetti()),
    ];
  }

  UNSAFE_componentWillReceiveProps(next) {
    this.impostaPaginaSelezionata(next);

    if (next.ufficioSelezionato != this.props.ufficioSelezionato) {
      this.verificaQuesitiNonLetti(next.ufficioSelezionato);
    }
  }

  componentWillUnmount() {
    this.eventiServerSubscriptions.forEach((unsubscribeFunc) => { unsubscribeFunc(); });
  }

  nuovoQuesitoCreato = () => {
    const { eventiServerContext } = this.props;
    eventiServerContext.fireEvent(messaggiServerEnum.NuovoQuesito, {});
    this.vaiAQuesiti(Enums.Quesiti.Aperti);
    this.verificaQuesitiNonLetti(this.props.ufficioSelezionato);
  };

  impostaPaginaSelezionata = (props) => {
    switch (props.match.params.stato) {
      case 'aperti': this.setState({
        visualizza: Visualizza.Quesiti,
        quesitiVisualizzati: Enums.Quesiti.Aperti,
        pannelloSelezionato: 0,
      });
        break;

      case 'chiusi': this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: Enums.Quesiti.Chiusi, pannelloSelezionato: 0 });
        break;

      case 'archiviati': this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: Enums.Quesiti.Archiviati, pannelloSelezionato: 0 });
        break;
    }

    if (props.match.params.idCanale) {
      this.setState({
        visualizza: Visualizza.Comunicazioni,
        pannelloSelezionato: 1,
        idCanaleSelezionato: props.match.params.idCanale,
      });
    }
  };

  caricaCanaliTematici = () => {
    Actions.canaliTematici().then((res) => {
      /* Ordino canali tematici per gruppo */

      const canaliTematiciPerGruppo = res.reduce((prev, item) => {
        if (!prev[item.Gruppo || item.Descrizione]) {
          const key = item.Gruppo || item.Descrizione;
          prev[key] = {
            ordinamento: item.Ordinamento,
            canali: [],
          };
        }

        if (item.Gruppo) {
          prev[item.Gruppo].canali.push(item);
        } else {
          prev[item.Descrizione].canali = item;
        }

        return prev;
      }, []);

      /* Converto oggetto in array, impostando la proprietà 'aperto' per aprire/chiudere il nodo della lista canali */

      const canaliOrdinati = [];

      Object.keys(canaliTematiciPerGruppo).map((x) => canaliOrdinati.push({
        ...canaliTematiciPerGruppo[x],
        gruppo: x,
        aperto: Array.isArray(canaliTematiciPerGruppo[x].canali)
          ? canaliTematiciPerGruppo[x].canali.some((y) => y.IdCanaleTematico == this.state.idCanaleSelezionato) || (this.state.canaliTematici.filter((y) => y.gruppo == x)[0] && this.state.canaliTematici.filter((y) => y.gruppo == x)[0].aperto)
          : canaliTematiciPerGruppo[x].canali.IdCanaleTematico == this.state.idCanaleSelezionato || (this.state.canaliTematici.filter((y) => y.gruppo == x)[0] && this.state.canaliTematici.filter((y) => y.gruppo == x)[0].aperto),
      }));

      this.props.impostaMessaggiDaLeggere(res.map((x) => x.NonLetti).reduce((a, b) => a + b, 0));

      this.setState({
        messaggiNonLetti: res.map((x) => x.NonLetti).reduce((a, b) => a + b, 0),
        canaliTematici: canaliOrdinati.sort((a, b) => a.ordinamento - b.ordinamento),
      });
    });
  };

  verificaQuesitiNonLetti = (ufficio) => {
    Actions.numeroPraticheDaLeggere(ufficio || this.props.ufficioSelezionato).then((res) => {
      this.props.impostaQuesitiDaLeggere(res.Aperte + res.Chiuse);
      this.setState({ numeroQuesitiNonLetti: res.Aperte + res.Chiuse, quesitiApertiNonLetti: res.Aperte, quesitiChiusiNonLetti: res.Chiuse });
    });
  };

  selezionaCanale = (idCanaletematico) => {
    if (this.props.match.params.idCanale != idCanaletematico) {
      this.setState({ visualizza: Visualizza.Comunicazioni, idCanaleSelezionato: idCanaletematico }, () => {
        this.props.history.push(`/messaggi/comunicazioni/${idCanaletematico}`);
      });
    }
  };

  vaiAQuesiti = (tipoQuesiti) => {
    if (this.state.visualizza == Visualizza.Quesiti && this.state.quesitiVisualizzati == tipoQuesiti && this.state.quesitiVisualizzati != Enums.Quesiti.Ricerca) {
      return;
    }

    if (tipoQuesiti == Enums.Quesiti.Aperti) {
      this.props.history.push('/messaggi/quesiti/aperti');
      this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: Enums.Quesiti.Aperti });
    } else if (tipoQuesiti == Enums.Quesiti.Chiusi) {
      this.props.history.push('/messaggi/quesiti/chiusi');
      this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: Enums.Quesiti.Chiusi });
    } else if (tipoQuesiti == Enums.Quesiti.Archiviati) {
      this.props.history.push('/messaggi/quesiti/archiviati');
      this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: Enums.Quesiti.Archiviati });
    } else if (tipoQuesiti == Enums.Quesiti.Ricerca) {
      this.props.history.push(`/messaggi/quesiti/ricerca/${this.state.ricerca}`);
      this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: Enums.Quesiti.Ricerca, ricerca: '' });
    }
  };

  onConversazioneLetta = (idPratica) => {
    const quesiti = [...this.state.quesiti];
    const idx = findIndex(quesiti, (x) => x.IdPratica == idPratica);
    quesiti[idx] = { ...quesiti[idx], LettaDaUtente: true };

    this.setState({ quesiti });
  };

  selezionaVisualizzati = (i) => {
    if (i == 0) {
      this.setState({ visualizza: Visualizza.Quesiti, quesitiVisualizzati: this.state.quesitiVisualizzati || Enums.Quesiti.Aperti }, () => {
        this.props.history.push(`/messaggi/quesiti/${this.state.quesitiVisualizzati ? Enums.Quesiti.toString(this.state.quesitiVisualizzati) : 'aperti'}`);
      });
    } else if (i == 1) {
      this.setState({ visualizza: Visualizza.Comunicazioni }, () => {
        this.props.history.push(`/messaggi/comunicazioni/${this.state.idCanaleSelezionato}`);
      });
    }
  };

  cerca = (evt) => {
    if (evt.key === 'Enter' && this.state.ricerca != null && this.state.ricerca.length > 2) {
      this.vaiAQuesiti(Enums.Quesiti.Ricerca);
    }
  };

  gestisciMostraCanali = (canale) => {
    this.setState({
      canaliTematici: this.state.canaliTematici.map((x) => {
        if (x == canale) {
          x.aperto = !x.aperto;
        }

        return x;
      }),
    });
  };

  render() {
    const apertiNonLetti = this.state.quesitiApertiNonLetti;
    const chiusiNonLetti = this.state.quesitiChiusiNonLetti;

    const servizioHelpdeskAttivo = (this.props.profilo != null) && this.props
      .profilo
      .Uffici
      .filter((x) => x.CodiceUfficio == parseInt(this.props.ufficioSelezionato, 10))[0]
      .Servizi
      .filter((z) => z.CodiceServizio == 'HLP')
      .length > 0;

    return (
      <div>
        <Toolbar
          title="Quesiti e messaggi"
          buttons={(
            <ButtonGroup>
              {this.props.ufficioSelezionato != null && servizioHelpdeskAttivo
                && (
                  <Button primary onClick={() => this.setState({ modaleNuovoQuesito: true })}>
                    Crea quesito
                  </Button>
                )}
            </ButtonGroup>
          )}
        />
        {this.props.profilo ? (
          <ProfiloContext.Provider value={this.props.profilo}>
            <ModaleNuovoQuesito
              show={this.state.modaleNuovoQuesito}
              ufficioSelezionato={this.props.ufficioSelezionato}
              onClose={() => this.setState({ modaleNuovoQuesito: false })}
              onOpenFeedbackConfermaInvio={() => { }}
              onCloseFeedbackConfermaInvio={() => {
                this.setState({ modaleNuovoQuesito: false });
                this.nuovoQuesitoCreato();
              }}
              router={this.context.router}
              origine="support"
            />
          </ProfiloContext.Provider>
        ) : null}
        <Grid fluid className="quesiti">
          <Row>
            <Col xs={12} md={3} className="quesiti__colFirst">
              <div className="quesiti__col" style={{ overflowY: 'auto' }}>

                <CustomAccordion onSelect={(i) => null} index={this.state.pannelloSelezionato}>

                  <CustomAccordion.Panel title="Quesiti" ref={(p) => this.quesiti = p} keepItOpen>
                    <ul className="quesiti__listaStati lista">
                      <li>
                        <Form onChange={(x) => this.setState(x)} stato={this.state}>
                          <Input placeholder="Cerca" name="ricerca" onKeyDown={(e) => this.cerca(e)} style={{ marginTop: '-10px' }} />
                          <SearchIcon className="iconaRicerca" />
                        </Form>
                      </li>
                      <li
                        style={{ backgroundColor: this.state.visualizza == Visualizza.Quesiti && this.state.quesitiVisualizzati == Enums.Quesiti.Aperti ? '#ebebeb' : '#ffffff' }}
                        onClick={() => this.vaiAQuesiti(Enums.Quesiti.Aperti)}
                      >
                        <OrarioIcon /> Aperti
                        {apertiNonLetti > 0 && <Badge alarm>{apertiNonLetti}</Badge>}
                      </li>
                      <li
                        style={{ backgroundColor: this.state.visualizza == Visualizza.Quesiti && this.state.quesitiVisualizzati == Enums.Quesiti.Chiusi ? '#ebebeb' : '#ffffff' }}
                        onClick={() => this.vaiAQuesiti(Enums.Quesiti.Chiusi)}
                      >
                        <BusinessContactIcon /> Chiusi
                        {chiusiNonLetti > 0 && <Badge alarm>{chiusiNonLetti}</Badge>}
                      </li>
                      <li
                        style={{ backgroundColor: this.state.visualizza == Visualizza.Quesiti && this.state.quesitiVisualizzati == Enums.Quesiti.Archiviati ? '#ebebeb' : '#ffffff' }}
                        onClick={() => this.vaiAQuesiti(Enums.Quesiti.Archiviati)}
                      >
                        <ArchivioIcon /> Archivio
                      </li>
                    </ul>
                  </CustomAccordion.Panel>

                  <CustomAccordion.Panel title="Messaggi" keepItOpen>
                    <ul className="comunicazioni__lista">
                      {this.state.canaliTematici.map((c, i) => (
                        <li key={i}>
                          {Array.isArray(c.canali) ? (
                            <div>
                              <span className="comunicazioni__titoloGruppo" onClick={() => this.gestisciMostraCanali(c)}>
                                <DownIcon className={c.aperto ? 'comunicazioni__iconaCanale--aperto' : 'comunicazioni__iconaCanale--chiuso'} />
                                <strong>{c.gruppo}</strong>
                                {c.canali.map((x) => x.NonLetti).reduce((a, b) => a + b, 0) > 0
                                  && <Badge alarm>{c.canali.map((x) => x.NonLetti).reduce((a, b) => a + b, 0)}</Badge>}
                              </span>
                              <ul className={c.aperto ? 'comunicazioni__gruppoCanali comunicazioni__gruppoCanali--aperto' : 'comunicazioni__gruppoCanali'}>
                                {c.canali.map((ct) => (
                                  <li
                                    key={ct.IdCanaleTematico}
                                    style={{ backgroundColor: this.state.visualizza == Visualizza.Comunicazioni && ct.IdCanaleTematico == this.state.idCanaleSelezionato ? '#ebebeb' : '#ffffff' }}
                                    onClick={() => this.selezionaCanale(ct.IdCanaleTematico)}
                                  >
                                    <span className="comunicazioni__titoloCanale">{ct.Descrizione}</span>
                                    {ct.NonLetti > 0 && <Badge alarm>{ct.NonLetti}</Badge>}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ) : (
                            <span
                              style={{ backgroundColor: this.state.visualizza == Visualizza.Comunicazioni && c.canali.IdCanaleTematico == this.state.idCanaleSelezionato ? '#ebebeb' : '#ffffff' }}
                              className="comunicazioni__canale"
                              onClick={() => this.selezionaCanale(c.canali.IdCanaleTematico)}
                            >
                              <strong>{c.canali.Descrizione}</strong>
                              {c.canali.NonLetti > 0 && <Badge alarm>{c.canali.NonLetti}</Badge>}
                            </span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </CustomAccordion.Panel>

                </CustomAccordion>

              </div>
            </Col>

            <Col xs={12} md={9} className="quesiti__colSecond">
              <Route path={`${this.props.match.path}/quesiti/ricerca/:testo`} component={ListaQuesiti} />
              <Route path={`${this.props.match.path}/quesiti/:stato`} component={ListaQuesiti} />
              <Route path={`${this.props.match.path}/comunicazioni/:idCanale`} component={ListaMessaggi} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

Messaggi.childContextTypes = {
  impostaQuesiti: PropTypes.func,
  verificaQuesitiNonLetti: PropTypes.func,
  caricaCanaliTematici: PropTypes.func,
};

Messaggi.contextTypes = {
  router: PropTypes.object,
};

const mapStateToProps = (state) => ({ profilo: state.profilo, ufficioSelezionato: state.ufficioSelezionato });

const mapDispatchToProps = (dispatch) => ({
  impostaMessaggiDaLeggere: (numero) => {
    dispatch({ type: 'IMPOSTA_MESSAGGI_DALEGGERE', numero });
  },
  impostaQuesitiDaLeggere: (numero) => {
    dispatch({ type: 'IMPOSTA_QUESITI_DALEGGERE', numero });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withEventiServer(Messaggi));
